"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storage_1 = require("./storage");
exports.handleActionOfOtherTab = function (e, dispatch) {
    if (e.key !== storage_1.defaultSpecialItemNameOfOtherTabsActions)
        return;
    if (!localStorage[storage_1.defaultSpecialItemNameOfOtherTabsActions])
        return;
    try {
        var lastAction = JSON.parse(localStorage[storage_1.defaultSpecialItemNameOfOtherTabsActions], storage_1.jsonDateParser);
        dispatch(lastAction);
    }
    catch (e) {
        return;
    }
};
